import userApi from '@/api/user'

const user = {
    state: {
        token: localStorage.getItem('token'),
        name: localStorage.getItem('name'),
        avatar: localStorage.getItem('avatar'),
        code: localStorage.getItem('code'),
        id: localStorage.getItem('id'),
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_CODE: (state, code) => {
            state.code = code
        },
        SET_ID: (state, id) => {
            state.id = id
        }
    },

    actions: {
        // 登录 by code
        Login({commit}, {code, inviter = ''}) {
            return new Promise((resolve, reject) => {
                userApi.login(code, inviter).then(response => {
                    localStorage.setItem('name', response.name)
                    localStorage.setItem('token', response.token)
                    localStorage.setItem('avatar', response.avatar)
                    commit('SET_TOKEN', response.token)
                    commit('SET_NAME', response.name)
                    commit('SET_AVATAR', response.avatar)
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        GetUserInfo({commit, state}) {
            // 同步服务器信息
            return new Promise((resolve, reject) => {
                userApi.getMyInfo().then(r => {
                    localStorage.setItem('avatar', r.avatar)
                    localStorage.setItem('name', r.name)
                    localStorage.setItem('id', r.id)
                    localStorage.setItem('code', r.code)
                    commit('SET_AVATAR', r.avatar)
                    commit('SET_NAME', r.name)
                    commit('SET_CODE', r.code)
                    commit('SET_ID', r.id)
                    resolve()
                }).catch( e => {
                    reject(e)
                })
            })
        },

        SetAvatar({commit}, avatar) {
            // 重新上传头像
            return new Promise((resolve, reject) => {
                userApi.setAvatar(avatar).then((res)=> {
                    commit('SET_AVATAR', res.avatar)
                    localStorage.setItem('avatar', res.avatar)
                    resolve()
                }).catch( e => {
                    reject(e)
                })

            })
        },
        SetName({commit}, name) {
            // 重设名称
            return new Promise((resolve, reject) => {
                localStorage.setItem('name', name)
                commit('SET_NAME', name)
                userApi.setName(name).then(()=> {
                    resolve()
                }).catch( e => {
                    reject(e)
                })
            })
        }
        // 获取用户信息
        // GetInfo({ commit, state }) {
        //   return new Promise((resolve, reject) => {
        //     getInfo(state.token).then(response => {
        //       const data = response.data
        //       if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
        //         commit('SET_ROLES', data.roles)
        //       } else {
        //         reject('getInfo: roles must be a non-null array !')
        //       }
        //       commit('SET_AVATAR', data.avatar)
        //       resolve(response)
        //     }).catch(error => {
        //       reject(error)
        //     })
        //   })
        // },

        // 登出
        // LogOut({commit, state}) {
        //     return new Promise((resolve, reject) => {
        //         logout(state.token).then(() => {
        //             commit('SET_TOKEN', '')
        //             commit('SET_AUTH', false)
        //             commit('SET_NAME', '')
        //             removeToken()
        //             resolve()
        //         }).catch(error => {
        //             reject(error)
        //         })
        //     })
        // },

        // 前端 登出
        // FedLogOut({commit}) {
        //     return new Promise(resolve => {
        //         commit('SET_TOKEN', '')
        //         commit('SET_AUTH', false)
        //         commit('SET_NAME', '')
        //         removeToken()
        //         resolve()
        //     })
        // }
    }
}

export default user
